import useIntersectionObserver from "@utils/useIntersectionObserver";
import * as _ from "underscore";
const fallback = require('@assets/images/fallback.png')

const VideoViewer = (props) => {
    const videoRef = useIntersectionObserver(_.debounce((entries) => {
        const entry = entries[0]
        const target = entry.target
        if (entry.isIntersecting) {
            if (target.src != target.dataset.src) target.src = target.dataset.src
            target.play().catch(err => console.error(err))
        } else {
            target.pause()
        }
    }, 10))

    return (
        <video
            ref={videoRef}
            style={{width: "100%", height: "100%", objectFit:"contain"}}
            data-src={props.src}
            preload="none"
            poster={fallback}
            loop
            muted
            type="video/mp4"
        />
    )
}

export default VideoViewer